module.exports = __webpack_public_path__ + "static/media/geral.4d2bc59e.svg";